import { render, staticRenderFns } from "./WeChats.vue?vue&type=template&id=fdb8790a&scoped=true&"
import script from "./WeChats.vue?vue&type=script&lang=js&"
export * from "./WeChats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb8790a",
  null
  
)

export default component.exports